import { render, staticRenderFns } from "./orderWork.vue?vue&type=template&id=d052a4b6&scoped=true"
import script from "./orderWork.vue?vue&type=script&lang=js"
export * from "./orderWork.vue?vue&type=script&lang=js"
import style0 from "./orderWork.vue?vue&type=style&index=0&id=d052a4b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d052a4b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d052a4b6')) {
      api.createRecord('d052a4b6', component.options)
    } else {
      api.reload('d052a4b6', component.options)
    }
    module.hot.accept("./orderWork.vue?vue&type=template&id=d052a4b6&scoped=true", function () {
      api.rerender('d052a4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components-cool/orderWork.vue"
export default component.exports